import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import axios from "axios";
import { useSelector } from "react-redux";
import { RootUrl } from "../redux/types";
import { useLocation } from "react-router-dom";
const GetPageData = (url) => {
  const [ready, setReady] = React.useState(false);
  const [data, setData] = React.useState(false);
  const [error, setError] = React.useState(false);
  const location = useLocation();
  const language = useSelector((state) => state.util.language);
  const getData = async () => {
    if (url) {
      await axios
        .get(`${RootUrl}/${url}/${language}`, {
          // body: JSON.stringify(url),
          headers: {
            "Content-Type": "application/json",

            // "Access-Control-Allow-Origin": "*",
          },
        })

        .then((res) => {
          console.log("response", res.data);
          setData(res?.data?.data);
          setReady(true);
        })
        .catch((err) => setError(err));
    }
  };

  React.useEffect(() => {
    getData();
  }, [location.pathname]);
  return {
    ready,
    data,
    error,
  };
};
export default GetPageData;
